(function () {
  var MAP_SCRIPT_ID = 'dkhoun-google-maps-js';
  var mapsLoader = null;

  function injectMapsScript(apiKey, language) {
    var previous = document.getElementById(MAP_SCRIPT_ID);
    if (previous) {
      if (window.google && window.google.maps && typeof window.google.maps.Map === 'function') return Promise.resolve();
      return new Promise(function (resolve, reject) {
        previous.addEventListener('load', function () { resolve(); }, { once: true });
        previous.addEventListener('error', function () { reject(new Error('Google Maps failed to load')); }, { once: true });
      });
    }
    return new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.id = MAP_SCRIPT_ID;
      script.async = true;
      script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(apiKey) + '&language=' + language + '&v=weekly&loading=async';
      script.onload = function () { resolve(); };
      script.onerror = function () { reject(new Error('Google Maps failed to load')); };
      document.head.appendChild(script);
    });
  }

  function loadGoogleMaps(apiKey, language) {
    if (window.google && window.google.maps && typeof window.google.maps.Map === 'function') {
      return Promise.resolve(window.google.maps);
    }
    if (mapsLoader) return mapsLoader;
    mapsLoader = (async function () {
      await injectMapsScript(apiKey, language);
      var deadline = Date.now() + 8000;
      while (Date.now() < deadline) {
        var maps = window.google && window.google.maps;
        if (maps && typeof maps.importLibrary === 'function') await maps.importLibrary('maps');
        if (maps && typeof maps.Map === 'function') return maps;
        await new Promise(function (resolve) { window.setTimeout(resolve, 30); });
      }
      throw new Error('Google Maps Map constructor is missing');
    })().catch(function (error) {
      mapsLoader = null;
      throw error;
    });
    return mapsLoader;
  }

  function embedUrl(point, language) {
    if (!point) return '';
    return 'https://maps.google.com/maps?q=' + point.latitude + ',' + point.longitude + '&hl=' + language + '&z=14&output=embed';
  }

  function measureSlot(slot) {
    var rect = slot.getBoundingClientRect();
    return { top: rect.top, left: rect.left, width: rect.width, height: rect.height };
  }

  function slotClip(box) {
    var right = Math.max(0, window.innerWidth - box.left - box.width);
    var bottom = Math.max(0, window.innerHeight - box.top - box.height);
    return 'inset(' + box.top + 'px ' + right + 'px ' + bottom + 'px ' + box.left + 'px round 12px)';
  }

  window.DkhounBranchesMap = {
    init: function (root, options) {
      var slot = root.querySelector('[data-map-slot]');
      var frame = root.querySelector('[data-map-frame]');
      var canvas = root.querySelector('[data-map-canvas]');
      var embed = root.querySelector('[data-map-embed]');
      var apiKey = root.getAttribute('data-maps-key') || '';
      var pinUrl = root.getAttribute('data-pin-url') || '';
      var language = (document.documentElement.lang || 'ar').toLowerCase().indexOf('ar') === 0 ? 'ar' : 'en';
      var state = {
        origin: options.origin || null,
        branches: options.branches || [],
        focus: options.focus || [],
        map: null,
        maps: null,
        markers: [],
        fitted: false,
        morphing: false,
        fullscreen: false
      };

      function showEmbed(point) {
        if (!embed) return;
        embed.hidden = false;
        if (canvas) canvas.hidden = true;
        var target = point || (state.focus[0] && state.focus[0].coords) || (state.branches[0] && state.branches[0].coords);
        if (target) embed.src = embedUrl(target, language);
      }

      function fitClosest() {
        if (!state.map || !state.maps || state.morphing) return;
        var camera = state.focus.length ? state.focus : state.branches;
        if (!camera.length && !state.origin) return;
        if (camera.length <= 1 && !state.origin) {
          state.map.setCenter({ lat: camera[0].coords.latitude, lng: camera[0].coords.longitude });
          state.map.setZoom(15);
          return;
        }
        var bounds = new state.maps.LatLngBounds();
        if (state.origin) bounds.extend({ lat: state.origin.latitude, lng: state.origin.longitude });
        camera.forEach(function (branch) {
          bounds.extend({ lat: branch.coords.latitude, lng: branch.coords.longitude });
        });
        var box = slot ? measureSlot(slot) : null;
        if (box && window.innerWidth > box.width && window.innerHeight > box.height && state.fullscreen) {
          state.map.fitBounds(bounds, {
            top: Math.round((window.innerHeight - box.height) / 2) + 56,
            right: Math.round((window.innerWidth - box.width) / 2) + 56,
            bottom: Math.round((window.innerHeight - box.height) / 2) + 56,
            left: Math.round((window.innerWidth - box.width) / 2) + 56
          });
          return;
        }
        state.map.fitBounds(bounds, 56);
      }

      function youAreHereMarkup(label) {
        return '<span class="dkhoun-you-are-here__bubble">' + label + '</span>' +
          '<span class="dkhoun-you-are-here__figure">' +
          '<span class="dkhoun-you-are-here__beat"></span>' +
          '<span class="dkhoun-you-are-here__beat"></span>' +
          '<span class="dkhoun-you-are-here__beat"></span>' +
          '<span class="dkhoun-you-are-here__dot"></span></span>';
      }

      var YouAreHereOverlay = null;

      function ensureYouAreHereOverlay() {
        if (YouAreHereOverlay) return YouAreHereOverlay;
        function Overlay(latLng, label) {
          this.latLng = latLng;
          this.label = label;
          this.div = null;
        }
        Overlay.prototype = Object.create(state.maps.OverlayView.prototype);
        Overlay.prototype.constructor = Overlay;
        Overlay.prototype.onAdd = function () {
          var div = document.createElement('div');
          div.className = 'dkhoun-you-are-here';
          div.innerHTML = youAreHereMarkup(this.label);
          this.div = div;
          this.getPanes().floatPane.appendChild(div);
        };
        Overlay.prototype.draw = function () {
          if (!this.div || !this.getProjection()) return;
          var point = this.getProjection().fromLatLngToDivPixel(this.latLng);
          if (!point) return;
          this.div.style.left = point.x + 'px';
          this.div.style.top = point.y + 'px';
        };
        Overlay.prototype.onRemove = function () {
          if (this.div && this.div.parentNode) this.div.parentNode.removeChild(this.div);
          this.div = null;
        };
        YouAreHereOverlay = Overlay;
        return YouAreHereOverlay;
      }

      function placeYouAreHere() {
        if (!state.map || !state.maps) return;
        if (!state.origin) {
          if (state.youAreHere) {
            state.youAreHere.setMap(null);
            state.youAreHere = null;
          }
          return;
        }
        var latLng = new state.maps.LatLng(state.origin.latitude, state.origin.longitude);
        var label = (window.DkhounBranchesI18n && window.DkhounBranchesI18n.you_are_here) || (language === 'ar' ? 'انت هنا' : 'You are here');
        if (!state.youAreHere) {
          var Overlay = ensureYouAreHereOverlay();
          state.youAreHere = new Overlay(latLng, label);
          state.youAreHere.setMap(state.map);
          return;
        }
        state.youAreHere.latLng = latLng;
        state.youAreHere.draw();
      }

      function escapeHtml(value) {
        return String(value || '').replace(/[&<>"']/g, function (char) {
          return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
        });
      }

      function distanceKm(from, to) {
        var toRad = function (deg) { return (deg * Math.PI) / 180; };
        var dLat = toRad(to.latitude - from.latitude);
        var dLng = toRad(to.longitude - from.longitude);
        var lat1 = toRad(from.latitude);
        var lat2 = toRad(to.latitude);
        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
        return 2 * 6371 * Math.asin(Math.min(1, Math.sqrt(a)));
      }

      function formatKm(km) {
        var value = km < 10 ? km.toFixed(1) : String(Math.round(km));
        return language === 'ar' ? value.replace('.', ',') : value;
      }

      function distanceLabel(branch) {
        if (!state.origin || !branch.coords) return '';
        var km = typeof branch.distanceKm === 'number' ? branch.distanceKm : distanceKm(state.origin, branch.coords);
        if (!isFinite(km)) return '';
        var template = (window.DkhounBranchesI18n && window.DkhounBranchesI18n.distance_km) || '{{distance}} km';
        return template.replace('{{distance}}', formatKm(km));
      }

      var PinPopover = null;
      var pinPopover = null;

      function ensurePinPopover() {
        if (PinPopover) return PinPopover;
        function Overlay() {
          this.div = null;
          this.latLng = null;
          this.pending = null;
        }
        Overlay.prototype = Object.create(state.maps.OverlayView.prototype);
        Overlay.prototype.constructor = Overlay;
        Overlay.prototype.render = function () {
          if (!this.div || !this.pending) return;
          var branch = this.pending;
          var distance = distanceLabel(branch);
          this.div.innerHTML = '<strong>' + escapeHtml(branch.name) + '</strong>' +
            (distance ? '<span>' + escapeHtml(distance) + '</span>' : '');
          this.div.hidden = false;
          this.draw();
        };
        Overlay.prototype.onAdd = function () {
          var div = document.createElement('div');
          div.className = 'dkhoun-pin-popover';
          div.hidden = true;
          this.div = div;
          this.getPanes().floatPane.appendChild(div);
          if (this.pending) this.render();
        };
        Overlay.prototype.draw = function () {
          if (!this.div || !this.latLng || !this.getProjection()) return;
          var point = this.getProjection().fromLatLngToDivPixel(this.latLng);
          if (!point) return;
          this.div.style.left = point.x + 'px';
          this.div.style.top = point.y + 'px';
        };
        Overlay.prototype.show = function (branch) {
          this.pending = branch;
          this.latLng = new state.maps.LatLng(branch.coords.latitude, branch.coords.longitude);
          if (this.div) this.render();
        };
        Overlay.prototype.hide = function () {
          this.pending = null;
          if (this.div) this.div.hidden = true;
        };
        Overlay.prototype.onRemove = function () {
          if (this.div && this.div.parentNode) this.div.parentNode.removeChild(this.div);
          this.div = null;
        };
        PinPopover = Overlay;
        return PinPopover;
      }

      function showPinPopover(branch) {
        if (!pinPopover) {
          pinPopover = new (ensurePinPopover())();
          pinPopover.setMap(state.map);
        }
        pinPopover.show(branch);
      }

      function hidePinPopover() {
        if (pinPopover) pinPopover.hide();
      }

      function drawMarkers() {
        if (!state.map || !state.maps) return;
        hidePinPopover();
        state.markers.forEach(function (marker) { marker.setMap(null); });
        state.markers = [];
        var pinIcon = {
          url: pinUrl,
          scaledSize: new state.maps.Size(44, 44),
          anchor: new state.maps.Point(22, 42)
        };
        state.branches.forEach(function (branch) {
          var marker = new state.maps.Marker({
            map: state.map,
            position: { lat: branch.coords.latitude, lng: branch.coords.longitude },
            optimized: false,
            icon: pinIcon
          });
          marker.addListener('mouseover', function () {
            marker.setZIndex(1000);
            showPinPopover(branch);
          });
          marker.addListener('mouseout', hidePinPopover);
          marker.addListener('click', function () {
            hidePinPopover();
            if (window.DkhounBranches && window.DkhounBranches.open) window.DkhounBranches.open(branch.handle);
          });
          state.markers.push(marker);
        });
        placeYouAreHere();
        if (!state.fitted) {
          fitClosest();
          state.fitted = true;
        }
        window.setTimeout(bindPinImages, 0);
      }

      function closestBranch(lat, lng) {
        var best = null;
        var bestDistance = Infinity;
        state.branches.forEach(function (branch) {
          var dLat = branch.coords.latitude - lat;
          var dLng = branch.coords.longitude - lng;
          var score = dLat * dLat + dLng * dLng;
          if (score < bestDistance) {
            bestDistance = score;
            best = branch;
          }
        });
        return best;
      }

      function bindPinImages() {
        if (!canvas || !state.map) return;
        if (!pinPopover) {
          pinPopover = new (ensurePinPopover())();
          pinPopover.setMap(state.map);
        }
        var projection = pinPopover.getProjection();
        if (!projection) {
          window.setTimeout(bindPinImages, 40);
          return;
        }
        var canvasRect = canvas.getBoundingClientRect();
        var imgs = canvas.querySelectorAll('img[src*="dkhoun-branch-pin"]');
        if (!imgs.length) {
          window.setTimeout(bindPinImages, 40);
          return;
        }
        [].forEach.call(imgs, function (img) {
          if (img.dataset.pinBound) return;
          var rect = img.getBoundingClientRect();
          if (!rect.width) return;
          var point = new state.maps.Point(rect.left - canvasRect.left + rect.width / 2, rect.bottom - canvasRect.top - 2);
          var latLng = projection.fromContainerPixelToLatLng(point);
          if (!latLng) return;
          var branch = closestBranch(latLng.lat(), latLng.lng());
          if (!branch) return;
          img.dataset.pinBound = '1';
          img.addEventListener('mouseenter', function () { showPinPopover(branch); });
          img.addEventListener('mouseleave', hidePinPopover);
        });
      }

      function mount(maps) {
        if (!canvas || state.map) return;
        state.maps = maps;
        var center = (state.origin || (state.branches[0] && state.branches[0].coords) || { latitude: 24.7136, longitude: 46.6753 });
        state.map = new maps.Map(canvas, {
          center: { lat: center.latitude, lng: center.longitude },
          zoom: 13,
          mapTypeId: 'roadmap',
          backgroundColor: '#ffffff',
          disableDefaultUI: true,
          gestureHandling: 'greedy',
          clickableIcons: false,
          styles: [
            { featureType: 'road', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'transit', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'landscape', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'water', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'poi', elementType: 'geometry', stylers: [{ visibility: 'off' }] },
            { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
            { featureType: 'poi.government', elementType: 'labels', stylers: [{ visibility: 'on' }] },
            { featureType: 'poi.school', elementType: 'labels', stylers: [{ visibility: 'on' }] },
            { featureType: 'poi.place_of_worship', elementType: 'labels', stylers: [{ visibility: 'on' }] },
            { featureType: 'administrative', elementType: 'labels', stylers: [{ visibility: 'on' }] }
          ]
        });
        if (embed) embed.hidden = true;
        canvas.hidden = false;
        drawMarkers();
      }

      if (apiKey) {
        loadGoogleMaps(apiKey, language).then(mount).catch(function () {
          showEmbed(state.origin);
        });
      } else {
        showEmbed(state.origin);
      }

      function fabIconSvg(open) {
        if (open) {
          return '<svg data-map-fab-icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M5.625 3.75a2.625 2.625 0 1 0 0 5.25h12.75a2.625 2.625 0 0 0 0-5.25H5.625ZM3.75 11.25a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75ZM3 15.75a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 0 1.5H3.75a.75.75 0 0 1-.75-.75ZM3.75 18.75a.75.75 0 0 0 0 1.5h16.5a.75.75 0 0 0 0-1.5H3.75Z"/></svg>';
        }
        return '<svg data-map-fab-icon xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M9 18 3 20V6l6-2 6 2 6-2v14l-6 2-6-2z"/><path d="M9 4v14M15 6v14"/></svg>';
      }

      function setFullscreen(open) {
        if (!frame || !slot || state.morphing) return;
        state.morphing = true;
        state.fullscreen = open;
        var box = measureSlot(slot);
        if (open) {
          frame.style.setProperty('--dkhoun-map-clip', slotClip(box));
          frame.classList.add('is-overlay');
          window.requestAnimationFrame(function () {
            window.requestAnimationFrame(function () {
              frame.style.setProperty('--dkhoun-map-clip', 'inset(0px 0px 0px 0px round 0px)');
            });
          });
        } else {
          frame.style.setProperty('--dkhoun-map-clip', slotClip(box));
          window.setTimeout(function () {
            frame.classList.remove('is-overlay');
            frame.style.removeProperty('--dkhoun-map-clip');
          }, 480);
        }
        window.setTimeout(function () {
          state.morphing = false;
          if (state.map && state.maps) state.maps.event.trigger(state.map, 'resize');
        }, 520);
        var fabLabel = root.querySelector('[data-map-fab-label]');
        var fabIcon = root.querySelector('[data-map-fab-icon]');
        if (fabLabel) fabLabel.textContent = open ? (root.getAttribute('data-list-label') || 'List') : (root.getAttribute('data-map-label') || 'Map');
        if (fabIcon) fabIcon.outerHTML = fabIconSvg(open);
      }

      function toggleMapColumn() {
        var open = root.classList.toggle('is-map-open');
        var fabLabel = root.querySelector('[data-map-fab-label]');
        var fabIcon = root.querySelector('[data-map-fab-icon]');
        if (fabLabel) fabLabel.textContent = open ? (root.getAttribute('data-list-label') || 'List') : (root.getAttribute('data-map-label') || 'Map');
        if (fabIcon) fabIcon.outerHTML = fabIconSvg(open);
        window.setTimeout(function () {
          if (state.map && state.maps) {
            state.maps.event.trigger(state.map, 'resize');
            state.fitted = false;
            fitClosest();
          }
        }, 60);
      }

      var fab = root.querySelector('[data-map-fab]');
      if (fab) fab.addEventListener('click', toggleMapColumn);
      var zoomIn = root.querySelector('[data-zoom-in]');
      var zoomOut = root.querySelector('[data-zoom-out]');
      var locate = root.querySelector('[data-map-locate]');
      if (zoomIn) zoomIn.addEventListener('click', function () { if (state.map) state.map.setZoom((state.map.getZoom() || 13) + 1); });
      if (zoomOut) zoomOut.addEventListener('click', function () { if (state.map) state.map.setZoom((state.map.getZoom() || 13) - 1); });
      if (locate) {
        locate.addEventListener('click', function () {
          state.fitted = false;
          if (options.onDetect) {
            Promise.resolve(options.onDetect()).then(function () { fitClosest(); });
            return;
          }
          fitClosest();
        });
      }

      return {
        update: function (next) {
          state.origin = next.origin || null;
          state.branches = next.branches || state.branches;
          state.focus = next.focus || [];
          state.fitted = false;
          if (state.map) drawMarkers();
          else if (!apiKey) showEmbed(state.origin);
        }
      };
    }
  };
})();
